const AnchorNavSchema = (props) => ({
  title: 'AgSUS Anchor Nav',
  fieldsets: [
    { id: 'default', title: 'Conteúdo', fields: ['items'] },
    { id: 'style', title: 'Estilo', fields: ['align', 'sticky'] },
  ],
  properties: {
    items: {
      title: 'Itens',
      description:
        'Cada item precisa de um label e um anchor (ID alvo, com ou sem # — ex.: "quem" ou "#quem").',
      widget: 'object_list',
      schema: {
        title: 'Item',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: ['label', 'anchor', 'destaque'],
          },
        ],
        properties: {
          label: { title: 'Texto no menu' },
          anchor: {
            title: 'Âncora (id da seção)',
            description: 'Ex.: quem, pilares, governanca',
          },
          destaque: {
            title: 'Destacar como chamada',
            description:
              'Mostra este item como botão cheio, para a ação principal da página (ex.: inscrição, contato).',
            type: 'boolean',
          },
        },
        required: ['label', 'anchor'],
      },
    },
    align: {
      title: 'Alinhamento',
      choices: [
        ['left', 'Esquerda'],
        ['center', 'Centro'],
      ],
      default: 'left',
    },
    sticky: {
      title: 'Fixo no topo (sticky)',
      type: 'boolean',
      default: true,
    },
  },
  required: [],
});

export default AnchorNavSchema;
